import React, { Component, useState } from 'react';
import { Trans, withI18n } from '@lingui/react';

function ServicePopup({serviceItem, onClose}) {

  const handleClose = () => {
    onClose();
  }

  return (
    <div className="service-popup">
     <div className="content-wrapper">
      <button className="button--close" onClick={() => handleClose()}>
          <div className="inner">
            <label>Close</label>
          </div>
        </button>
        <div className="left-wrapper">
          <img src={serviceItem.imageUrl} alt={serviceItem.title} />
        </div>
        <div className="right-wrapper">
          <div><h3>{serviceItem.title}</h3></div>
          <div className="description" dangerouslySetInnerHTML={{ __html: serviceItem.description }} />
        </div>
      </div>
    </div>
  )
}

export default withI18n()(ServicePopup);
